import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UsersService } from '../../services/users.service'
import { ActivatedRoute, Router } from '@angular/router';
import { ThemePalette } from '@angular/material/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common'
import { ROUTES, AdminLayoutRoutes } from '../../classes/routes'
import * as jq from 'jquery';
import { BehaviorSubject, forkJoin } from 'rxjs';

import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { GlobalsService } from '../../services/globals.service'
import { SocketService } from '../../services/socket.service'
import { pathGrantableByEditor } from '../../utils/menu-path-access';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';


declare let $: any;

export interface Access {
	title: string;
	authorized: boolean;
	color: ThemePalette;
	children ? : Access[];
}

export interface Modify {
	title: string;
	authorized: boolean;
	color ? : ThemePalette;
	children ? : Modify[];
}

@Component({
	selector: 'app-user-groups-edit',
	templateUrl: './user-groups-edit.component.html',
	styleUrls: ['./user-groups-edit.component.scss'],
	animations: [
		trigger('fadeInAnimation', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('500ms', style({ opacity: 1 })),
			]),
		]),
		trigger('listItemAnimation', [
			transition('* => *', [
				query('.mat-list-item', [
					style({ opacity: 0, transform: 'translateY(-20px)' }),
					stagger('100ms', [
						animate('300ms', style({ opacity: 1, transform: 'translateY(0)' })),
					]),
				]),
			]),
		]),
	],
})

export class UserGroupsEditComponent implements OnInit {

	title = 'User Group';
	group: any = []
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	placedfrom = [{
		name: 'BackOffice',
		value: 1
	},
	{
		name: 'Point Of Sale',
		value: 2
	},
	{
		name: 'Street',
		value: 3
	},
	{
		name: 'Ecom',
		value: 4
	},
	{
		name: 'Retail',
		value: 5
	}
	]


	ROUTES = ROUTES;
	userForm: UntypedFormGroup;
	groupname = new UntypedFormControl('');
	saleschannel = new UntypedFormControl(1);
	group_id: any = '';
	permissions: any = [];
	allAccess = false;
	ipRestricted = false;
	allowedIPs: string[] = [];
	task: any = [];
	access: any = [];
	labelPosition: 'before' | 'after' = 'after';
	access_list: any = [];
	CHAT_ROOM = 'Users';
	color = 'blue';
	group_access: any = [];
	all_reports: any = [];
	group_reports: any = [];
	active_reports: any = []
	base_group_reports: any = [];
	all_reports_unfiltered: any = [];
	/** Per report-section (grouped `type`) filter text */
	reportSectionFilters: Record<string, string> = {};
	allUsers: any = [];
	groupUsers: any = [];
	selecteduser: any = false;
	userDetails: any = false;
	filteredAllUsers: any[] = [];
	filteredGroupUsers: any[] = [];
	searchAllTerm = '';
	searchGroupTerm = '';

	constructor(private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, private userService: UsersService, public router: Router, private location: Location, public globalSearchService: GlobalSearchService, private globalsService: GlobalsService, public socketService: SocketService) {
		const accesss = [];
		this.color = this.globalSearchService.getColor();

		ROUTES.forEach((l) => {
			const link = {
				title: l.title,
				authorized: false,
				children: [],
				path: l.path,
				group: l.anchor,
			};

			if (l.children) {
				l.children.forEach(child => {
					const childauth = {
						title: child.title,
						authorized: false,
						path: child.path,
						children: [],
						group: l.anchor,
					};
					link.children.push(childauth);
				});
			}
			this.access_list.push(link);
		})
	}

	pathGrantable(path: string): boolean {
		return pathGrantableByEditor(path, this.globalSearchService.user.getValue());
	}

	parentMenuDisabled(route: any): boolean {
		if (this.pathGrantable(route.path)) {
			return false;
		}
		return !route.children?.some((c: any) => this.pathGrantable(c.path));
	}

	branchIndeterminate(route: any): boolean {
		if (!route.children?.length) {
			return false;
		}
		let on = 0;
		for (const c of route.children) {
			if (c.authorized) {
				on++;
			}
		}
		return on > 0 && on < route.children.length;
	}

	ngOnInit(): void {
		this.route.params.subscribe(params => {
			this.group_id = params['id'];
			this.loadData();
		});
	}

	// Function to add a new allowed IP
	addAllowedIPs(ipListString: string) {
		const ips = ipListString.split(',').map(ip => ip.trim());
		this.allowedIPs.push(...ips);
	}

	// Function to remove an allowed IP at a given index
	removeAllowedIP(index: number) {
		this.allowedIPs.splice(index, 1);
	}


	loadData() {
		this.userService.getUserGroup(this.group_id).subscribe((group: any) => {
			this.groupname.setValue(group.name);
			this.saleschannel.setValue(group.sales_channel)
			if(group.ip_restricted === '0') {
				this.ipRestricted = false;
			} else { 
				this.ipRestricted = group.ip_restricted
			}

			if (group.allowed_ips && !group.allowed_ips.length && group.allowed_ips != '') {
				this.allowedIPs = []
			} else {
				this.allowedIPs = group.allowed_ips;
			}
			//

			const auth = this.access_list.map(bc => bc.path);

			this.group_access = group.access
			this.access_list.forEach((a, index) => {
				this.access_list[index].authorized = this.allowed(a.path)
				if (a.children) {
					a.children.forEach(child => {
						const allowed = this.allowed(child.path)
						child.authorized = allowed
						if (allowed) {
							//parent access permitted if child is
							this.access_list[index].authorized = true;
						}
					})
				}
			})
			this.group = group;

			this.getUsers();

			this.loadReports();
		});
	}

	getUsers() {
		this.userService.getUsers().subscribe((users: any) => {
			this.groupUsers = users.filter((user: any) => user.user_group === this.group_id);
			this.allUsers = users.filter((user: any) => user.user_group !== this.group_id);
			this.filteredAllUsers = [...this.allUsers];
			this.filteredGroupUsers = [...this.groupUsers];
			
			setTimeout(() => {
				this.filterAllUsers();
				this.filterGroupUsers();
			  }, 0);
			  
		});
	}
	
	



	filterAllUsers() {

		if (this.searchAllTerm) {
			this.filteredAllUsers = this.allUsers.filter(user =>
				(user?.realname?.toLowerCase() ?? '').includes(this.searchAllTerm.toLowerCase()) ||
				(user?.userid?.toString() ?? '').includes(this.searchAllTerm) ||
				(user?.phone ?? '').includes(this.searchAllTerm) ||
				(user?.email?.toLowerCase() ?? '').includes(this.searchAllTerm.toLowerCase()) ||
				(user?.defaultlocation?.toLowerCase() ?? '').includes(this.searchAllTerm.toLowerCase())
			);

		} else {
			this.filteredAllUsers = [...this.allUsers];
		}
	}

	filterGroupUsers() {
		if (this.searchGroupTerm) {
			this.filteredGroupUsers = this.groupUsers.filter(user =>
				(user?.realname?.toLowerCase() ?? '').includes(this.searchGroupTerm.toLowerCase()) ||
				(user?.userid?.toString() ?? '').includes(this.searchGroupTerm) ||
				(user?.phone ?? '').includes(this.searchGroupTerm) ||
				(user?.email?.toLowerCase() ?? '').includes(this.searchGroupTerm.toLowerCase()) ||
				(user?.defaultlocation?.toLowerCase() ?? '').includes(this.searchGroupTerm.toLowerCase())
			);
		} else {
			this.filteredGroupUsers = [...this.groupUsers];
		}
	}

	addUserToGroup(user: any) {
	  const data = {
			userid: user.userid,
			group_id: this.group_id
	  };
	
	  this.userService.addUserToGroup(data).subscribe((result: any) => {
			if (result.success) {
		  this.getUsers();
		  
			}
	  });
	}
	
	removeUserFromGroup(user: any) {
	  const data = {
			userid: user.userid,
			group_id: this.group_id
	  };
	
	  this.userService.removeUserFromGroup(data).subscribe((result: any) => {
			if (result.success) {
		  this.getUsers();
		  
			}
	  });
	}

	// Function to toggle the addition/removal of a report from the group
	toggleReport(report: any): void {
		if (this.hasLocation(report.title)) {
			this.removeUserReport(report);
		} else {
			this.addUserReport(report);
		}
	}


	loadReports() {
		this.userService.getAllReports(this.group_id).subscribe((all_reports: any) => {
			this.all_reports_unfiltered = all_reports || [];
			this.all_reports = this.sortAndGroupReports(this.all_reports_unfiltered);
			this.userService.getGroupReports(this.group_id).subscribe((group_reports: any) => {
				this.group_reports = this.sortAndGroupReports(group_reports);
				this.base_group_reports = group_reports;
				this.active_reports = group_reports;
			});
		})
	}
	addUserReport(report: any) {
		const payload = {
			groupid: this.group_id,
			report: report.title,
		}
		this.userService.addReport(payload).subscribe((all_reports: any) => {
			this.loadReports();
		});
	}

	setReportSectionFilter(sectionType: string, value: string): void {
		this.reportSectionFilters[sectionType] = value ?? '';
	}

	filteredReportsInSection(group: { type: string; reports: any[] }): any[] {
		if (!group?.reports?.length) {
			return [];
		}
		const term = (this.reportSectionFilters[group.type] || '').toLowerCase().trim();
		if (!term) {
			return group.reports;
		}
		return group.reports.filter((r: any) => {
			const title = (r?.title ?? '').toString().toLowerCase();
			const typ = (r?.type ?? '').toString().toLowerCase();
			return title.includes(term) || typ.includes(term);
		});
	}

	checkAllFilteredInSection(group: { type: string; reports: any[] }): void {
		const targets = this.filteredReportsInSection(group).filter((r: any) => !this.hasLocation(r.title));
		this.runReportToggleRequests(targets.map((r: any) => ({ report: r, add: true })));
	}

	uncheckAllFilteredInSection(group: { type: string; reports: any[] }): void {
		const targets = this.filteredReportsInSection(group).filter((r: any) => this.hasLocation(r.title));
		this.runReportToggleRequests(targets.map((r: any) => ({ report: r, add: false })));
	}

	private runReportToggleRequests(ops: { report: any; add: boolean }[]): void {
		if (!ops.length) {
			return;
		}
		const requests = ops.map(({ report, add }) =>
			add
				? this.userService.addReport({ groupid: this.group_id, report: report.title })
				: this.userService.removeReport({ groupid: this.group_id, report: report.title })
		);
		forkJoin(requests).subscribe({
			next: () => this.loadReports(),
			error: () => this.globalSearchService.showNotification('Failed to update some report permissions', 'error', 'bottom', 'left'),
		});
	}

	private reportExportFileSlug(scope: 'all' | 'section', sectionType?: string): string {
		const safeName = (this.group?.name || 'user-group')
			.toString()
			.replace(/[^a-z0-9-_]+/gi, '-')
			.replace(/^-+|-+$/g, '') || 'user-group';
		const id = this.group_id ?? 'group';
		if (scope === 'section' && sectionType) {
			const sec = sectionType.toString().replace(/[^a-z0-9-_]+/gi, '-').replace(/^-+|-+$/g, '') || 'section';
			return `report-access-${safeName}-${id}-${sec}`;
		}
		return `report-access-${safeName}-${id}-all`;
	}

	private buildReportExportRows(sectionType?: string): { Section: string; Title: string; Type: string; Granted: string }[] {
		let list = this.all_reports_unfiltered || [];
		if (sectionType) {
			list = list.filter((r: any) => r.type === sectionType);
		}
		return list.map((r: any) => ({
			Section: (r?.type ?? '').toString(),
			Title: (r?.title ?? '').toString(),
			Type: (r?.type ?? '').toString(),
			Granted: this.hasLocation(r?.title) ? 'Yes' : 'No',
		}));
	}

	exportReportsXlsx(scope: 'all' | 'section', sectionType?: string): void {
		const rows = this.buildReportExportRows(scope === 'section' ? sectionType : undefined);
		if (!rows.length) {
			this.globalSearchService.showNotification('Nothing to export', 'warning', 'bottom', 'left');
			return;
		}
		const name = this.reportExportFileSlug(scope, sectionType);
		this.globalSearchService.exportJsonToExcel(rows, name);
	}

	exportReportsPdf(scope: 'all' | 'section', sectionType?: string): void {
		const rows = this.buildReportExportRows(scope === 'section' ? sectionType : undefined);
		if (!rows.length) {
			this.globalSearchService.showNotification('Nothing to export', 'warning', 'bottom', 'left');
			return;
		}
		const title =
			scope === 'all'
				? `Report access — ${this.group?.name || 'User group'} (all sections)`
				: `Report access — ${this.group?.name || 'User group'} — ${sectionType || ''}`;
		const doc = new jsPDF({ orientation: 'landscape' });
		doc.setFontSize(11);
		doc.text(title, 14, 12);
		autoTable(doc, {
			startY: 18,
			head: [['Section', 'Title', 'Type', 'Granted']],
			body: rows.map(r => [r.Section, r.Title, r.Type, r.Granted]),
			styles: { fontSize: 8, cellPadding: 2 },
			headStyles: { fillColor: [66, 66, 66] },
		});
		doc.save(`${this.reportExportFileSlug(scope, sectionType)}.pdf`);
	}

	removeUserReport(report: any) {
		const payload = {
			groupid: this.group_id,
			report: report.title,
		}
		this.userService.removeReport(payload).subscribe((all_reports: any) => {
			this.loadReports();
		});
	}

	hasLocation(title: any) {
		//this.user becomes false when modalService closes
		let access = []

		if (this.all_reports) {
			access = this.active_reports.filter(loc => {
				return loc.title == title;
			})
		};

		return (access.length > 0) ? true : false;
	}

	allowed(path: any): boolean {
		const a = this.group_access.indexOf(path);
		return (a < 0) ? false : true;
	}

	back(): void {
		this.location.back()
	}

	updateAccess(completed: boolean, parent: any, child: any) {
		if (!this.pathGrantable(child.path)) {
			return false;
		}
		const parent_index = this.access_list.indexOf(parent);
		const child_index = this.access_list[parent_index].children.indexOf(child)

		if (!completed) {
			this.allAccess = false;
		}
		if (this.access_list[parent_index].children[child_index] == null) {
			return false;
		}

		this.access_list[parent_index].children[child_index].authorized = completed;
		this.access_list[parent_index].authorized = this.access_list[parent_index].children.some((t: any) => t.authorized);
		return this.access_list[parent_index].children[child_index].authorized

	}

	setChildAccessAuthorized(completed: boolean, parent: any) {
		const index = this.access_list.indexOf(parent);
		if (index < 0) {
			return;
		}
		if (!completed) {
			this.allAccess = false;
		}
		const row = this.access_list[index];
		if (!row.children?.length) {
			if (this.pathGrantable(row.path)) {
				row.authorized = completed;
			}
			return;
		}
		row.children.forEach((t: any) => {
			if (this.pathGrantable(t.path)) {
				t.authorized = completed;
			}
		});
		row.authorized = row.children.some((t: any) => t.authorized);
	}

	setAllAccess(completed: boolean) {
		this.allAccess = completed

		this.access_list.forEach(t => {
			if (this.pathGrantable(t.path)) {
				t.authorized = completed;
			}
			t.children.forEach((child: any) => {
				if (this.pathGrantable(child.path)) {
					child.authorized = completed;
				}
			});
		});
	}

	saveAccess() {
		let data = { 
			access: this.access_list, 
			group: this.group, 
			name: this.groupname.value, 
			groupid: this.group_id, 
			ip_restrict: this.ipRestricted, 
			allowedips: this.allowedIPs, 
			sales_channel: this.saleschannel.value 
		};
		
		this.userService.updateGroup(data).subscribe((result: any) => {
			data = result;
			
			// Broadcast permission update via socket
			this.socketService.sendUserGroupUpdate({ data, roomName: this.CHAT_ROOM }, () => {});
			
			this.loadData();
			this.globalSearchService.showNotification('Modified - Broadcasting to all users', 'success', 'bottom', 'left');
		}, (error) => {
			this.globalSearchService.showNotification('Failed to update group permissions', 'error', 'bottom', 'left');
		});
	}


	sortAndGroupReports(reports: any[]): any[] {
		// Handle null, undefined, or empty reports
		if (!reports || !Array.isArray(reports) || reports.length === 0) {
			return [];
		}

		// Sort the reports alphabetically by title
		reports.sort((a, b) => {
			const titleA = (a?.title || '').toString().toLowerCase();
			const titleB = (b?.title || '').toString().toLowerCase();
			return titleA.localeCompare(titleB);
		});

		// Group the reports by type
		const groupedReports = {};
		reports.forEach(report => {
			if (!groupedReports[report.type]) {
				groupedReports[report.type] = [];
			}
			groupedReports[report.type].push(report);
		});

		// Convert the groupedReports object into an array of objects
		const result = [];
		for (const type in groupedReports) {
			if (groupedReports.hasOwnProperty(type)) {
				result.push({ type, reports: groupedReports[type] });
			}
		}

		return result;
	}

	trackByFn(index: number, item: any): number {
		return item.title;
	}

	trackByFnTwo(index: number, item: any): number {
		return item.type;
	}
}